import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { STATUS, STORAGE_KEYS } from '../constants'
import { Layout } from '../layout'
import { useAppDispatch, useAppSelector } from '../redux-store/hooks'
import { logIntoApp } from '../redux-store/reducers'
import { MaskLoader, StartupLoader } from '../screens'
import { LinearProgress } from '@mui/material'
import { SocketProvider } from '../realtime'

interface PrivateRouteProps {
  children: JSX.Element
  isLoaderActive: boolean
  toggleTheme: () => void
  increaseFontSize: () => void
  decreaseFontSize: () => void
  canIncreaseFontSize: boolean
  canDecreaseFontSize: boolean
  selectedServerUrl: string | null
  onServerChange: (serverUrl: string) => void
}

const DashboardPrivateRoute: FC<PrivateRouteProps> = ({
  children,
  isLoaderActive,
  toggleTheme,
  increaseFontSize,
  decreaseFontSize,
  canIncreaseFontSize,
  canDecreaseFontSize,
  selectedServerUrl,
  onServerChange,
}) => {
  const navigate = useNavigate()
  const dispatcher = useAppDispatch()
  const authToken = useAppSelector((state) => state.authentication.token)
  const loadState = useAppSelector((state) => state.clientInfo.status)
  const location = useLocation()
  const isKitchenRoute = location.pathname === '/app/kitchen'

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN)
    const userId = localStorage.getItem(STORAGE_KEYS.USER_ID)
    if (token && userId) {
      dispatcher(logIntoApp({ token, userId }))
    } else {
      navigate('/login')
    }
  }, [authToken, loadState, navigate, dispatcher])

  if (loadState !== STATUS.SUCCESS) {
    return <StartupLoader />
  }

  return (
    <>
      {isLoaderActive &&
        (isKitchenRoute ? (
          <LinearProgress
            color="warning"
            sx={{ position: 'absolute', top: 0, width: '100%', zIndex: 10 }}
          />
        ) : (
          <MaskLoader />
        ))}
        {/* {isLoaderActive && <MaskLoader />} */}
        <Layout
          isLoaderActive={isLoaderActive}
          toggleTheme={toggleTheme}
          increaseFontSize={increaseFontSize}
          decreaseFontSize={decreaseFontSize}
          canIncreaseFontSize={canIncreaseFontSize}
          canDecreaseFontSize={canDecreaseFontSize}
          selectedServerUrl={selectedServerUrl}
          onServerChange={onServerChange}
        >
          {children}
        </Layout>
    </>
  )
}

export default DashboardPrivateRoute
